import * as Actions from 'store/actions/app/proforma_items.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_items_by_proforma: false,
  items_by_proforma: [],

  saving_proforma_item: false,
  saved_proforma_item: false,

  adding_quantity_to_proforma_item_ids: [],
  added_quantity_to_proforma_item_ids: [],

  subtracting_quantity_to_proforma_item_ids: [],
  subtracted_quantity_to_proforma_item_ids: [],

  saving_proforma_item_description_ids: [],
  saved_proforma_item_description_ids: [],

  updating_proforma_item_quantity_ids: [],
  updated_proforma_item_quantity_ids: [],

  updating_proforma_item_price_ids: [],
  updated_proforma_item_price_ids: [],

  removing_proforma_item_ids: [],
  removed_proforma_item_ids: [],
}

const proformaItemsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ITEMS_BY_PROFORMA_ID: {
      return {
        ...state,
        loading_items_by_proforma: action.payload.loading,
        items_by_proforma: action.payload.data ?? state.items_by_proforma,
      }
    }
    case Actions.SAVE_PROFORMA_ITEM: {
      return {
        ...state,
        saved_proforma_item: action.payload.saved ?? false,
        saving_proforma_item: action.payload.saving ?? false,
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id', true)
          : state.items_by_proforma
      }
    }
    case Actions.ADD_QUANTITY_TO_PROFORMA_ITEM: {
      return {
        ...state,
        adding_quantity_to_proforma_item_ids: toggleIdInArray(state.adding_quantity_to_proforma_item_ids, action.payload.adding_id),
        added_quantity_to_proforma_item_ids: toggleIdInArray(state.added_quantity_to_proforma_item_ids, action.payload.added_id),
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id')
          : state.items_by_proforma
      }
    }
    case Actions.SUBTRACT_QUANTITY_TO_PROFORMA_ITEM: {
      return {
        ...state,
        subtracting_quantity_to_proforma_item_ids: toggleIdInArray(state.subtracting_quantity_to_proforma_item_ids, action.payload.subtracting_id),
        subtracted_quantity_to_proforma_item_ids: toggleIdInArray(state.subtracted_quantity_to_proforma_item_ids, action.payload.subtracted_id),
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id')
          : state.items_by_proforma
      }
    }
    case Actions.SAVE_PROFORMA_ITEM_DESCRIPTION: {
      return {
        ...state,
        saving_proforma_item_description_ids: toggleIdInArray(state.saving_proforma_item_description_ids, action.payload.saving_id),
        saved_proforma_item_description_ids: toggleIdInArray(state.saved_proforma_item_description_ids, action.payload.saved_id),
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id')
          : state.items_by_proforma
      }
    }
    case Actions.UPDATE_PROFORMA_ITEM_QUANTITY: {
      return {
        ...state,
        updating_proforma_item_quantity_ids: toggleIdInArray(state.updating_proforma_item_quantity_ids, action.payload.updating_id),
        updated_proforma_item_quantity_ids: toggleIdInArray(state.updated_proforma_item_quantity_ids, action.payload.updated_id),
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id')
          : state.items_by_proforma
      }
    }
    case Actions.UPDATE_PROFORMA_ITEM_PRICE: {
      return {
        ...state,
        updating_proforma_item_price_ids: toggleIdInArray(state.updating_proforma_item_price_ids, action.payload.updating_id),
        updated_proforma_item_price_ids: toggleIdInArray(state.updated_proforma_item_price_ids, action.payload.updated_id),
        items_by_proforma: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_proforma, action.payload.data, 'id')
          : state.items_by_proforma
      }
    }
    case Actions.REMOVE_PROFORMA_ITEM: {
      return {
        ...state,
        removing_proforma_item_ids: toggleIdInArray(state.removing_proforma_item_ids, action.payload.removing_id),
        removed_proforma_item_ids: toggleIdInArray(state.removed_proforma_item_ids, action.payload.removed_id),
        items_by_proforma: state.items_by_proforma.filter(item => item.id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}

export default proformaItemsReducer
